<script lang="ts" setup>
import { computed, defineProps } from "vue";
import type { TripMonitorTruck } from "@/api/trips/dto/trip-monitor";
import GoogleMapsMixin from "@/mixins/google-maps.mixin";
import { DAY_IN_SECONDS, HOUR_IN_SECONDS, TWENTY_MINUTES_IN_SECONDS } from "@/data/time";
import CurrentLocationDot from "@/components/status/CurrentLocationDot.vue";
import type { CurrentLocationDotSettings } from "@/components/types";

const { getPlaceUrlByAddress } = GoogleMapsMixin.methods;

const props = defineProps<{
  truck: TripMonitorTruck | null;
}>();

const dotSettings = computed<CurrentLocationDotSettings[]>(() => {
  return [
    {
      seconds: DAY_IN_SECONDS,
      color: "grey",
    },
    {
      seconds: HOUR_IN_SECONDS,
      color: "orange",
    },
    {
      seconds: TWENTY_MINUTES_IN_SECONDS,
      color: "yellow",
    },
  ];
});
</script>

<template>
  <div>
    <div class="d-flex align-center mb-1">
      <div class="font-size-12 text-grey-darken-3 ml-2px" data-qa="truck-current-location">
        {{ props.truck?.currentLocation?.fullAddress }}
      </div>
      <a :href="getPlaceUrlByAddress(props.truck?.currentLocation?.fullAddress)" class="ml-2" target="_blank">
        <v-icon color="success" icon="mdi-map-marker-radius-outline" size="14"></v-icon>
      </a>
    </div>
    <current-location-dot
      v-if="props.truck?.currentLocationTime"
      :dot-settings="dotSettings"
      :time="props.truck?.currentLocationTime"
      dot-class="font-size-11 text-grey-darken-2 ml-3"
      show-tooltip
    />
  </div>
</template>
